<div class="container-fluid">
  <div class="proposal-detail-container">
    <!-- Page Header with Back Navigation -->
    <div class="page-header">
      <div class="header-content">
        <a href="/" class="back-link">
          <i class="pi pi-arrow-left"></i>
        </a>
        <div class="header-text">
          <h1 class="page-title">Proposal Details</h1>
        </div>
      </div>
      <div class="header-divider"></div>
    </div>

    <!-- Proposal Content -->
    <div class="proposal-content">
      <div class="proposal-info">
        <div class="proposal-header">
          <h2 class="proposal-name">{{proposal?.name}}</h2>
        </div>
        <p class="proposal-description">{{proposal?.description}}</p>

        <div class="row g-4 mb-4">
          <!-- Status Card -->
          <div class="col-md-3">
            <div class="card h-100 status-card">
              <div class="card-body">
                <div class="d-flex">
                  <div class="rounded-circle bg-primary-subtle p-3 me-3 icon-bg">
                    <i class="pi pi-clock text-primary"></i>
                  </div>
                  <div>
                    <small class="text-muted d-block">Status</small>
                    <h6 class="mb-0">{{proposal?.proposal_status | uppercase}}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Timeline Card -->
          <div class="col-md-3">
            <div class="card h-100 timeline-card">
              <div class="card-body">
                <div class="d-flex">
                  <div class="rounded-circle bg-warning-subtle p-3 me-3 icon-bg">
                    <i class="pi pi-calendar text-warning"></i>
                  </div>
                  <div>
                    <small class="text-muted d-block">Timeline</small>
                    <h6 class="mb-0">{{totalTimline}} weeks</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Team Members Card -->
          <div class="col-md-3">
            <div class="card h-100 team-card">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="rounded-circle bg-info-subtle p-3 me-3 icon-bg">
                    <i class="pi pi-users text-info"></i>
                  </div>
                  <div>
                    <small class="text-muted d-block">Team Members</small>
                    <p-avatarGroup>
                      <!-- Show unique users only -->
                      <ng-container *ngFor="let member of getUniqueTeamMembers()">
                        <p-avatar [image]="member.user.avatar" size="normal" [label]="member.user.first_name.charAt(0)"
                          shape="circle" [title]="member.user.first_name + ' ' + member.user.last_name">
                        </p-avatar>
                      </ng-container>
                    </p-avatarGroup>
                    <!-- <small *ngIf="teamMembers.length > 4" class="text-muted mt-1 d-block">
                      +{{teamMembers.length - 4}} more
                    </small> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Add a 4th card for balance -->
          <div class="col-md-3">
            <div class="card h-100 milestone-card">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="rounded-circle bg-success-subtle p-3 me-3 icon-bg">
                    <i class="pi pi-check-circle text-success"></i>
                  </div>
                  <div>
                    <small class="text-muted d-block">Completion</small>
                    <h6 class="mb-0">{{progress}}% Complete</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Rest of your existing content remains the same -->
  <div class="mt-6 mb-6">
    <app-calendar (stepsLoaded)="onStepsReceived($event)" (phase)="activePhaseId"></app-calendar>
  </div>

  <!-- Project Progress and Team Members -->
  <div class="row g-4 mt-4">
    <!-- Project Progress -->
    <div class="col-md-6">
      <div class="card project-progress-card">
        <div class="card-body p-4">
          <!-- Header Section -->
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div>
              <h5 class="card-title mb-2">Proposal Progress</h5>
              <p class="text-muted mb-1 small">
                <i class="pi pi-folder-open me-2 folder"></i>
                Overall progress of the <span class="fw-medium">{{proposal?.name}}</span>
              </p>
            </div>
            <!-- <span class="phase-badge glow"> -->
              <!-- <i class="pi pi-{{getPhaseIcon(currentPhase)}} me-2"></i> -->
              <!-- {{currentPhase}}
            </span> -->
          </div>

          <!-- Progress Bar -->
          <div class="mb-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted small">Overall Progress</span>
              <span class="fw-bold" [ngStyle]="{'color': getProgressColor(progress)}">{{progress}}%</span>
            </div>
            <div class="progress">
              <div class="progress-bar progress-bar-striped" role="progressbar" [style.width.%]="progress"
                [ngStyle]="{'background-color': getProgressColor(progress)}" aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
          </div>

          <!-- Project Details Grid -->
          <div class="row g-3 mt-3">
            <div class="col-md-6">
              <div class="detail-item">
                <i class="pi pi-calendar-plus detail-icon red"></i>
                <div>
                  <span class="detail-label">Created on</span>
                  <span class="detail-value">{{proposal?.created_on | date:'MMMM d, y'}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-item">
                <i class="pi pi-calendar-plus detail-icon yellow"></i>
                <div>
                  <span class="detail-label">Modified on</span>
                  <span class="detail-value">{{proposal?.modified_on | date:'MMMM d, y'}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-item">
                <i class="pi pi-sitemap detail-icon purple"></i>
                <div>
                  <span class="detail-label">Stages</span>
                  <span class="detail-value">{{projectDetails.stages}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="detail-item">
                <i class="pi pi-clock detail-icon cgreen"></i>
                <div>
                  <span class="detail-label">Timeline</span>
                  <span class="detail-value">{{totalTimline}} weeks</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Team Members -->
    <div class="col-md-6">
      <div class="card border-0 team-collab">
        <div class="card-body p-4">
          <!-- Header with animated gradient border -->

          <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h5 class="card-title mb-1 fw-bold">Hierarchical Approval</h5>
              <p class="text-muted mb-0 small">View your Approval Route</p>
            </div>
            <i class="pi pi-users text-primary f-1"></i>
          </div>

          <!-- Team Members List - Modern Cards -->
          <div class="team-scroll-container">
            <div *ngFor="let memberGroup of groupedTeamMembers" class="team-member-card mb-3 p-3 rounded-3">
              <div class="d-flex align-items-start gap-3">
                <!-- Avatar with status -->
                <div class="position-relative">
                  <!-- <p-avatar [image]="memberGroup.user.avatar" [label]="memberGroup.user.first_name.charAt(0)"
                    shape="circle" size="large">
                  </p-avatar> -->
                  <i class="pi pi-user"></i>
                  <!-- <span class="position-absolute bottom-0 end-0 bg-success rounded-circle"></span> -->
                </div>

                <div class="flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 class="mb-0 fw-bold">{{ memberGroup.user.first_name }} {{
                        memberGroup.user.last_name }}</h6>
                      <span class="text-muted small">{{ memberGroup.user.position || 'Team Member' }}</span>
                    </div>
                    <!-- <button class="btn btn-sm btn-link text-primary p-0">
                  <i class="pi pi-send"></i>
                </button> -->
                  </div>

                  <!-- Roles as chips -->
                  <div class="mt-3">
                    <div *ngFor="let roleGroup of memberGroup.roles" class="mb-2">
                      <span class="badge rounded-pill mb-2"
                        >
                        {{ roleGroup.role }}
                      </span>
                      <ul class="list-unstyled mb-0 ps-0 small">
                        <li *ngFor="let step of roleGroup.steps" class="text-muted mb-1 d-flex align-items-start">
                          <i class="pi pi-check-circle text-success me-2 mt-1 f-08"></i>
                          <span>{{ step }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Add Member Button with Floating Action -->
          <!-- <button class="btn btn-primary w-100 mt-4 rounded-pill py-2 d-flex align-items-center justify-content-center"
             >
        <i class="pi pi-plus me-2"></i>
        Add Team Member
      </button> -->
        </div>
      </div>
    </div>
  </div>

  <p-dialog header="Configure Route" [(visible)]="visible" [modal]="true" [resizable]="false" [closable]="true"
    [style]="{width: '60vw'}" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true"
    appendTo="body">
    <div class="p-3 mt-4">
      <form [formGroup]="routeForm" (ngSubmit)="onrouteFormSubmit()">
        <div class="row">
          <div class="col-md-6 mb-3 ">
            <label>Steps</label>
            <p-dropdown [options]="stagesList" formControlName="step" optionValue="id" optionLabel="name"
              placeholder="Select a Stage" class="w-100" (onChange)="onStepChange($event)" [filter]="true"
              filterBy="name">
            </p-dropdown>
          </div>
          <div class="col-md-6 mb-3" *ngIf="!this.routeForm.get('approved')?.value">
            <label>Role</label>
            <p-dropdown [options]="roleList" formControlName="role" optionValue="id" optionLabel="name"
              placeholder="Select a Role" class="w-100" [filter]="true" filterBy="name">
            </p-dropdown>
          </div>
          <div class="col-md-6 mb-3">
            <label>User</label>
            <p-dropdown [options]="userList" formControlName="user" optionValue="id" optionLabel="last_name"
              placeholder="Select a User" [filter]="true" filterBy="last_name" class="w-100">
            </p-dropdown>
          </div>
          <div class="col-md-6 mb-3 flex-col">
            <label for="menuIcon">Sequence</label>
            <input id="menuIcon" type="text" pInputText formControlName="level" placeholder="Enter Sequence"
              class="w-100" />
          </div>
          <div class="col-md-12 mb-3 d-flex justify-content-between">
            <div class=" mb-3 ad-user">
              <p-checkbox formControlName="approved" binary="true" inputId="ad_user"
                class="custom-checkbox me-3"></p-checkbox>
              <label for="ad_user">Approve</label>
            </div>
            <div class=" footer-btn  mt-6">
              <button pButton label="Submit" type="submit" class="fetch-data-btn"></button>
            </div>
          </div>

        </div>
      </form>



      <!-- MAke it table here -->

      <div class="mt-4  mb-4">
        <ng-container *ngIf="proposalData?.length > 0">
          <app-data-table [columns]="cols" [data]="proposalData" title="User to Proposal Mapping"
            [showAddButton]="false" [isDeletable]="true"></app-data-table>
        </ng-container>
      </div>

    </div>

  </p-dialog>